import React, { useState, useRef, useEffect } from "react";
import { toast } from "sonner";
import { backend, eventBackend } from "../../services";
import ManShortSelector from "../../components/ui/shortItemSelect";
import { AddUserModalProps, EventFullData, TaskUpdateStatusModalProps, UserShortInfo } from "../../types";
import { taskStatusNames, taskUserStatusNames } from "../../constants";
import DateInput from "../../components/ui/dateInput";
import { useSelector } from "react-redux";
import { RootState } from "../../state/reducer";

const TaskUpdateStatusModal: React.FC<TaskUpdateStatusModalProps> = ({
  task_id,
  def_status_id,
  def_date_end,
  onSave,
  closeModal,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<number>(def_status_id || 2); 
  const [selectedDateEnd, setSelectedDateEnd] = useState<string | undefined>(def_date_end); // Выбранный пользователь
  const [comment, setComment] = useState<string | undefined>(); // Комментарий
  const modalRef = useRef<HTMLDivElement>(null); // Ref для модального окна
  const [availableUsers, setAvailableUsers] = useState<UserShortInfo[]>([]);
  const State = useSelector((state: RootState) => state);
  const rights = State.rights;

  useEffect(() => {
     backend.getAllUsersShorts({ group_id: rights.group_ids[0]}).then((res) => {
        setAvailableUsers(res.users)
     }).catch((err) => {
        console.log(err);
        toast("Не удалось загрузить список пользователей");
     })
  }, [])

  // Закрытие модального окна с сохранением
  const closeWithSave = () => {
    if (!task_id) return;
        if (!comment) {
          toast("Комментарий обязателен");
          return;
        }
    onSave(task_id, selectedStatus, comment, selectedDateEnd); // Вызываем коллбэк с выбранным ID пользователя
    closeModal(); // Закрываем модальное окно
  };

  return (
    <div className="editModal" ref={modalRef}>
      <div className="modalHeading">
        <h3>Добавить пользователя</h3>
      </div>
      <div className="columnCenter creationForm">
        <div className="formField">
           <label htmlFor="status_id">Статус:</label>
           <select
             id="selectType"
             name="status_id"
             value={selectedStatus}
            onChange={(event) => setSelectedStatus(Number(event.target.value))}
          >
            {taskStatusNames.map((item, index) => {
              return <option key={`ts${index}`} value={item.id}>{item.name}</option>
            })}
          </select>
        </div>
        <div className="formField flex formRow">
          <label htmlFor="user">Дата выполнения</label>
          <DateInput
              value={selectedDateEnd || ""}
              onSelect={(dateTime) => setSelectedDateEnd(dateTime)}
            />
        </div>
        <div className="formField formRow commentRow">
          <label htmlFor="description">Комментарий</label>
          <textarea
            id="description"
            name="description"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
          />
        </div>
      </div>
      <div className="flex between btnRow">
        <button className="filterButton" type="button" onClick={closeWithSave}>
          Сохранить
        </button>
        <button className="cancelButton" type="button" onClick={closeModal}>
          Отменить
        </button>
      </div>
    </div>
  );
};

export default TaskUpdateStatusModal;